import image_logo from "../../assets/images/logo.svg";
import {
    PROVIDER,
    controllerLine,
    providerRoleSentence,
} from "../../config/legalEntities";

function TermsSubscriber() {
    const appName = process.env.REACT_APP_NAME || "TruHail";
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 py-10">
            <div className="mb-8 h-[80px] overflow-hidden rounded-2xl">
                <img
                    src={image_logo}
                    alt={`Logo ${appName}`}
                    height={80}
                    className="h-full w-full object-cover"
                />
            </div>

            <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md">
                <h1 className="mb-4 text-2xl font-bold">
                    Termos de Serviço — Assinante (Operadora Whitelabel)
                </h1>
                <p className="mb-6 text-sm text-gray-500">
                    Última atualização: 26 de fevereiro de 2026
                </p>
                <p className="mb-8 text-lg">
                    Estes Termos de Serviço (&quot;Termos&quot;) regulam a relação entre
                    a Provedora da Plataforma e o Assinante que licencia e opera o
                    aplicativo {appName} sob marca própria (whitelabel). A formalização
                    completa da relação comercial é feita através de contrato SaaS
                    específico firmado entre as partes.
                </p>

                <div className="space-y-8">
                    {/* 1. Definições */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">1. Definições</h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>&quot;Provedora da Plataforma&quot;</strong>:{" "}
                                {PROVIDER.name} (CNPJ {PROVIDER.cnpj}), empresa
                                responsável pelo desenvolvimento, manutenção, hospedagem e
                                licenciamento da infraestrutura tecnológica como serviço (SaaS).
                            </li>
                            <li>
                                <strong>&quot;Assinante&quot; ou &quot;Operadora&quot;</strong>:{" "}
                                {controllerLine} — empresa ou pessoa jurídica que contrata a
                                licença da Plataforma para operar sob marca própria (whitelabel)
                                e que atua como Controladora dos dados dos Usuários Finais.
                            </li>
                            <li>
                                <strong>&quot;Plataforma&quot;</strong>: o conjunto de
                                aplicativos (Motorista, Passageiro, Painel Administrativo) e
                                infraestrutura associada.
                            </li>
                            <li>
                                <strong>&quot;Usuários Finais&quot;</strong>: Motoristas e
                                Passageiros cadastrados pelo Assinante na Plataforma.
                            </li>
                            <li>
                                <strong>&quot;Contrato SaaS&quot;</strong>: contrato comercial
                                específico firmado entre a Provedora e o Assinante, que detalha
                                condições comerciais, níveis de serviço e obrigações específicas.
                            </li>
                        </ul>
                    </div>

                    {/* 2. Escopo do Serviço */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            2. Escopo do Serviço
                        </h2>
                        <p className="mb-2">
                            A Provedora da Plataforma fornece ao Assinante:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Licença de uso da Plataforma sob marca própria (whitelabel)
                            </li>
                            <li>
                                Hospedagem e infraestrutura de servidor (plano padrão) ou
                                suporte para hospedagem própria (plano empresarial/self-hosted)
                            </li>
                            <li>Manutenção e atualizações do software</li>
                            <li>Painel administrativo para gestão de Motoristas, Passageiros, veículos, corridas e configurações</li>
                            <li>
                                Integração com provedores de pagamento para split de valores
                            </li>
                            <li>Suporte técnico conforme nível contratado</li>
                        </ul>
                    </div>

                    {/* 3. Obrigações do Assinante */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            3. Obrigações do Assinante
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Cumprir todas as leis e regulamentações aplicáveis em sua
                                jurisdição, incluindo legislação de transportes, trabalhista,
                                consumerista e de proteção de dados
                            </li>
                            <li>
                                Gerenciar o relacionamento com Motoristas e Passageiros,
                                incluindo aprovação de cadastros, resolução de disputas e
                                suporte
                            </li>
                            <li>
                                Manter configurações de pagamento (chaves de API, tokens)
                                atualizadas e seguras no Painel Administrativo
                            </li>
                            <li>
                                Disponibilizar Termos de Uso e Política de Privacidade aos
                                Usuários Finais adequados à legislação local
                            </li>
                            <li>
                                Efetuar o pagamento da assinatura conforme condições do Contrato
                                SaaS
                            </li>
                            <li>
                                Não realizar engenharia reversa, cópia ou redistribuição do
                                software
                            </li>
                            <li>
                                No plano self-hosted: manter a infraestrutura de servidor
                                adequada e segura
                            </li>
                        </ul>
                    </div>

                    {/* 4. Proteção de Dados: Controlador vs Operador */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            4. Proteção de Dados — Controlador e Operador
                        </h2>
                        <p className="mb-2">
                            Em conformidade com as Leis de Proteção de Dados Aplicáveis
                            (incluindo, mas não limitada à LGPD — Lei nº 13.709/2018,
                            e regulamentações equivalentes em outras jurisdições):
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                O <strong>Assinante</strong> ({controllerLine}) atua como{" "}
                                <strong>Controlador de dados</strong> (Art. 5º, VI LGPD) em
                                relação aos dados dos Usuários Finais, sendo responsável pelas
                                decisões sobre o tratamento de dados pessoais
                            </li>
                            <li>
                                A <strong>Provedora da Plataforma</strong> ({PROVIDER.name},
                                CNPJ {PROVIDER.cnpj}) nunca é Controladora dos dados dos
                                Usuários Finais. Quando hospeda a Plataforma, atua como{" "}
                                <strong>Operadora de dados</strong> (Art. 5º, VII LGPD),
                                processando dados pessoais em nome e conforme instruções do
                                Assinante; quando o Assinante auto-hospeda (self-hosted), atua
                                exclusivamente como fornecedora do software (desenvolvedora).{" "}
                                {providerRoleSentence}
                            </li>
                            <li>
                                A Provedora da Plataforma implementa medidas técnicas e
                                organizacionais adequadas para proteger os dados pessoais
                                processados
                            </li>
                            <li>
                                O Assinante é responsável por garantir a base legal para coleta
                                e tratamento de dados dos Usuários Finais
                            </li>
                            <li>
                                Solicitações de titulares (acesso, correção, exclusão) devem ser
                                encaminhadas pelo Assinante à Provedora da Plataforma para
                                processamento técnico
                            </li>
                        </ul>
                    </div>

                    {/* 5. Pagamentos e Split */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            5. Divisão de Pagamentos
                        </h2>
                        <p className="mb-2">
                            Os valores de cada corrida são divididos conforme estrutura
                            definida no Contrato SaaS:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>Provedora da Plataforma:</strong> taxa fixa percentual
                                sobre cada corrida (definida no contrato)
                            </li>
                            <li>
                                <strong>Assinante (Operadora):</strong> comissão sobre cada
                                corrida, deduzida do valor pago pelo passageiro
                            </li>
                            <li>
                                <strong>Motorista:</strong> valor restante após as deduções da
                                Provedora e do Assinante
                            </li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-600">
                            A divisão de pagamentos é processada automaticamente através de
                            provedores de pagamento integrados à Plataforma.
                        </p>
                    </div>

                    {/* 6. Propriedade Intelectual */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            6. Propriedade Intelectual e Marca
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Todo o código-fonte, arquitetura, algoritmos e propriedade
                                intelectual da Plataforma pertencem exclusivamente à Provedora
                                da Plataforma
                            </li>
                            <li>
                                O Assinante recebe uma licença não-exclusiva, não-transferível e
                                revogável para uso da Plataforma sob sua própria marca
                            </li>
                            <li>
                                O Assinante pode customizar a marca visual (nome, logo, cores)
                                conforme funcionalidades disponíveis
                            </li>
                            <li>
                                A marca e identidade visual do Assinante permanecem de
                                propriedade do Assinante
                            </li>
                        </ul>
                    </div>

                    {/* 7. Nível de Serviço */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            7. Nível de Serviço
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A Provedora da Plataforma empenhará esforços razoáveis para
                                manter a disponibilidade do serviço, conforme SLA definido no
                                Contrato SaaS
                            </li>
                            <li>
                                Manutenções programadas serão comunicadas com antecedência
                                razoável
                            </li>
                            <li>
                                Interrupções por força maior, ataques cibernéticos ou falhas de
                                provedores terceiros não são de responsabilidade da Provedora
                            </li>
                        </ul>
                    </div>

                    {/* 8. Limitação de Responsabilidade */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            8. Limitação de Responsabilidade
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A Provedora da Plataforma não se responsabiliza por danos
                                diretos, indiretos, incidentais ou consequenciais decorrentes do
                                uso da Plataforma pelo Assinante ou seus Usuários Finais
                            </li>
                            <li>
                                A responsabilidade total da Provedora é limitada ao valor das
                                últimas 12 mensalidades pagas pelo Assinante
                            </li>
                            <li>
                                O Assinante é o único responsável pela operação comercial,
                                gestão de Motoristas e Passageiros, conformidade regulatória e
                                resolução de disputas locais
                            </li>
                        </ul>
                    </div>

                    {/* 9. Indenização */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">9. Indenização</h2>
                        <p>
                            O Assinante concorda em indenizar e isentar a Provedora da
                            Plataforma, seus diretores, funcionários e parceiros de quaisquer
                            reclamações, danos, perdas ou despesas decorrentes da operação
                            comercial do Assinante, violação de leis locais, ou uso indevido
                            da Plataforma.
                        </p>
                    </div>

                    {/* 10. Vigência e Rescisão */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            10. Vigência e Rescisão
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A vigência destes Termos acompanha o Contrato SaaS firmado entre
                                as partes
                            </li>
                            <li>
                                Em caso de rescisão, a Provedora da Plataforma garantirá a
                                portabilidade dos dados conforme legislação de proteção de dados
                                aplicável
                            </li>
                            <li>
                                Dados dos Usuários Finais serão mantidos pelo período mínimo
                                exigido por lei após a rescisão, e então eliminados
                            </li>
                            <li>
                                No plano self-hosted, o Assinante deverá cessar o uso do
                                software e destruir todas as cópias após a rescisão
                            </li>
                        </ul>
                    </div>

                    {/* 11. Legislação e Foro */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            11. Legislação Aplicável e Foro
                        </h2>
                        <p>
                            Estes Termos são regidos pelas leis aplicáveis na jurisdição da
                            Provedora da Plataforma. Eventuais litígios serão submetidos ao
                            foro competente conforme definido no Contrato SaaS ou, na ausência
                            de previsão contratual, o foro da sede da Provedora da Plataforma.
                        </p>
                    </div>

                    {/* 12. Provedores e Subprocessadores */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            12. Provedores e Subprocessadores
                        </h2>
                        <p className="mb-2">
                            Para operar a Plataforma, a Provedora compartilha dados pessoais
                            estritamente necessários com os subprocessadores listados abaixo,
                            cada um conforme sua finalidade específica (pagamentos,
                            notificações, mapas, distribuição de aplicativos e infraestrutura).
                            Recomenda-se a leitura das respectivas políticas:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>Mercado Pago</strong> (processamento de pagamentos e
                                split):{" "}
                                <a
                                    href="https://www.mercadopago.com.br/ajuda/termos-e-politicas_194"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos e políticas
                                </a>
                            </li>
                            <li>
                                <strong>OneSignal</strong> (notificações push):{" "}
                                <a
                                    href="https://onesignal.com/tos"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de Serviço
                                </a>
                            </li>
                            <li>
                                <strong>SendPulse</strong> (envio de e-mails e mensagens):{" "}
                                <a
                                    href="https://sendpulse.com/legal/termsofservice"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de Serviço
                                </a>
                            </li>
                            <li>
                                <strong>OpenStreetMap</strong> (dados de mapas):{" "}
                                <a
                                    href="https://operations.osmfoundation.org/policies/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Políticas
                                </a>
                            </li>
                            <li>
                                <strong>CARTO</strong> (serviços de geolocalização e mapas):{" "}
                                <a
                                    href="https://carto.com/legal"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos legais
                                </a>
                            </li>
                            <li>
                                <strong>Firebase / Google</strong> (infraestrutura, mensageria
                                e serviços de nuvem):{" "}
                                <a
                                    href="https://firebase.google.com/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                            <li>
                                <strong>Apple App Store</strong> (distribuição do aplicativo
                                iOS):{" "}
                                <a
                                    href="https://www.apple.com/legal/internet-services/itunes/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                            <li>
                                <strong>Google Play</strong> (distribuição do aplicativo
                                Android):{" "}
                                <a
                                    href="https://play.google.com/about/play-terms/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos
                                </a>
                            </li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-600">
                            As URLs e versões das políticas de terceiros podem mudar; confira
                            na data de acesso. Para exercício de direitos de titulares ou
                            dúvidas sobre subprocessadores, contate o Encarregado pela
                            Proteção de Dados (DPO):{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                            .
                        </p>
                    </div>

                    {/* 13. Contato */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">13. Contato</h2>
                        <p>
                            Para dúvidas sobre estes Termos ou o Contrato SaaS:{" "}
                            <a
                                href="mailto:software@trusom.com"
                                className="text-blue-600 underline"
                            >
                                software@trusom.com
                            </a>
                        </p>
                        <p className="mt-2">
                            Para questões sobre proteção de dados (DPO):{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsSubscriber;
